import React from 'react';
import { HiRefresh } from 'react-icons/hi';
import { Box, Button, FormLabel, Grid } from '@tq/ui-components';
import { useTranslation } from 'react-i18next';
import { COLOURS } from '@tq/ui-components/dist/pp2/theme';
import { GetIncomingConsultationsResponse } from 'api';
import { SearchText } from '..';
import { incomingConsultationsByReferenceNumberState } from 'store';

export interface SearchPlanningApplicationsProps {
  incomingConsultationsData?: GetIncomingConsultationsResponse;
  refetchData?: () => void;
}

const DESKTOP_TEMPLATE = `
 "view view"
 "searchText refreshButton "`;

const MOBILE_TEMPLATE = `
"view"
"searchText"
"refreshButton"
 / 1fr 1fr 1fr
`;

export const SearchPlanningApplications: React.FC<SearchPlanningApplicationsProps> = ({
  incomingConsultationsData,
  refetchData,
}) => {
  const { t } = useTranslation('traffic_monitor');

  return (
    <>
      <Grid
        gridGap={{ base: 4, lg: 1 }}
        pt={4}
        pb={7}
        px={5}
        mx={{ base: -5, md: 0 }}
        justifyContent={{ base: 'center', lg: 'unset' }}
        gridTemplate={{
          base: MOBILE_TEMPLATE,
          lg: DESKTOP_TEMPLATE,
        }}
        borderColor={COLOURS.gray[400]}
        borderWidth={1}
        borderRadius={5}
        backgroundColor={COLOURS.gray[200]}
      >
        <FormLabel id='view_type_label' gridArea='view'>
          {t('search_planning_applications', 'Search for planning applications:')}
        </FormLabel>
        <>
          <Box gridArea='searchText' width={570}>
            <SearchText
              searchState={incomingConsultationsByReferenceNumberState}
              placeholderText={t('placeholder_consultations', 'Search consultations')}
              recordCount={
                incomingConsultationsData?.incomingConsultations?.items?.length ?? 0
              }
              totalCount={incomingConsultationsData?.paginationInfo?.totalCount ?? 0}
            />
          </Box>
          <Box gridArea='refreshButton' mr={330}>
            <Button
              data-testid='refreshButton'
              isFullWidth
              variant='secondary'
              rightIcon={<HiRefresh />}
              width={250}
              onClick={() => refetchData && refetchData()}
              disabled={!incomingConsultationsData?.incomingConsultations?.items?.length}
            >
              {t('refresh_table', 'Refresh table')}
            </Button>
          </Box>
        </>
      </Grid>
    </>
  );
};
